<template>
  <div class="content-create">
    <bread-crumb></bread-crumb>
    <div class="wrap">
      <p class="c-title">内容创作</p>
      <div class="content flex flex-wrap-wrap">
        <!-- <div class="item flex flex-direction-column justify-content-center align-items-center">
          <img class="tuwen" src="" alt="">
          <p>图文</p>
        </div>
        <div class="item flex flex-direction-column justify-content-center align-items-center">
          <img class="shipin" src="" alt="">
          <p>图文</p>
        </div>
        <div class="item flex flex-direction-column justify-content-center align-items-center">
          <img class="wenda" src="" alt="">
          <p>图文</p>
        </div> -->
        <div class="item flex flex-direction-column justify-content-center align-items-center have" v-for="(item,index) in articleTypeList" :key="index" @click="toSpecifiedPage(item)" @mouseenter="itemHoverOn" @mouseleave="itemHoverOff">
          <img class="wenda unhov" :src="imgHost+item.iconUrl" alt="">
          <p>{{item.name}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import breadCrumb from "../../../../components/breadCrumb";
  import {listArticleTypesByPin} from '@/api/user.js'
  export default {
    name: "contentCreate",
    components:{
      breadCrumb
    },
    data() {
      return {
        articleTypeList:[],
        imgHost:'//image.healthjd.com/da/'
      }
    },
    created() {
      this.getListArticleTypesByPin()
    },
    methods: {
      // 获取用户的文章类型
      getListArticleTypesByPin() {
        listArticleTypesByPin({tenantId:this.$commonJs.getTenantId()}).then(res => {
          this.articleTypeList = res
        })
      },
      // 点击图文视频跳转指定页
      toSpecifiedPage(target) {
        // 如果是百科，清空百科的暂存的文章信息，因为从入口进入需要新建，所有表单值是空的
        if(target.articleType == 8){
          this.$commonJs.removeCacheArticleData(undefined);
        }
        this.$router.push({
          path:`${target.url}`,
          query:{articleType:target.contentType}
        })
      },
      // 图标鼠标移上显示高亮
      itemHoverOn(dom){
        $(dom.target || dom.srcElement).find('img').removeClass('unhov');
      },
      // 图标鼠标离开显示灰色
      itemHoverOff(dom){
        $(dom.target || dom.srcElement).find('img').addClass('unhov');
      },
    }
  }
</script>

<style scoped lang="scss">
.have{
    cursor:pointer
  }
  .content-create{
    .wrap{
      padding: 22px 26px;
      background: white;
      border-radius: 4px;
      .content{
        margin-top: 30px;
        .item{
          width: 180px;
          height: 180px;
          background: rgba(255,255,255,1);
          border: 1px solid rgba(237,240,246,1);
          border-radius: 4px;
          margin-right: 20px;
          cursor: pointer;
          .tuwen{
            width: 40px;
            height:40px;
            margin-bottom: 26px;
          }
          .shipin{
            width: 42px;
            heihght:36px;
            margin-bottom: 28px;
          }
          .wenda{
            width: 40px;
            height: 37px;
            margin-bottom: 27px;
          }
          .unhov{
            filter: grayscale(100%);
            filter: gray;
          }
        }
      }
    }
  }
</style>
